import firebase from "firebase/compat/app";
import "firebase/compat/storage";

export class FirebaseStorageClient {
  private storageRef: firebase.storage.Reference;

  constructor(firebaseInstance: typeof firebase) {
    this.storageRef = firebaseInstance.storage().ref();
  }

  async uploadFile(file: File, path: string): Promise<string> {
    const fileRef = this.storageRef.child(path);
    const snapshot = await fileRef.put(file);
    const downloadURL = await snapshot.ref.getDownloadURL();
    return downloadURL;
  }

  async deleteFile(path: string): Promise<void> {
    let fileRef: firebase.storage.Reference;

    if (path.includes('firebasestorage.googleapis.com')) {
      fileRef = this.storageRef.storage.refFromURL(path);
    } else {
      fileRef = this.storageRef.child(path);
    }
    
    await fileRef.delete();
  }

  async getDownloadURL(path: string): Promise<string> {
    const fileRef = this.storageRef.child(path);
    return await fileRef.getDownloadURL();
  }

  async fileExists(path: string): Promise<boolean> {
    try {
      const fileRef = this.storageRef.child(path);
      await fileRef.getDownloadURL();
      return true;
    } catch (error: any) {
      if (error.code === 'storage/object-not-found') {
        return false;
      }
      throw error;
    }
  }
}